// import Swiper from 'swiper/bundle';
import Swiper from 'swiper/bundle';

class MvSwiper {
  constructor(el) {
    this.el = el;
    this.swiper = this._initSwiper();
  }

  _initSwiper() {
    return new Swiper(this.el, {
      loop: true,
      grabCursor: true,
      // effect: 'fade',
      centeredSlides: true,
      slidesPerView: 1,
      speed: 1000,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      spaceBetween: 8,
      breakpoints: {
        980: {
          spaceBetween: 50,
          slidesPerView: 1.1,
        },
        1920: {
          spaceBetween: 100,
          slidesPerView: 1.2,
        },
      },
    });
  }

  start(op) {
    this.options = Object.assign(
      {
        delay: 5000,
        disableOnInteraction: false,
      },
      op
    );
    this.swiper.params.autoplay = this.options;
    this.swiper.autoplay.start();
  }
  stop() {
    this.autoplay.stop();
  }
}

class ArticleNavigationSwiper {
  constructor(el) {
    this.el = el;
    this.swiper = this._initSwiper();
  }

  _initSwiper() {
    return new Swiper(this.el, {
      loop: false,
      grabCursor: true,
      slidesPerView: 2.7,
      speed: 1000,
      breakpoints: {
        480: {
          slidesPerView: 3.7,
        },
        640: {
          slidesPerView: 4,
        },
      },
    });
  }

  start(op) {
    this.options = Object.assign(
      {
        delay: 1000,
        disableOnInteraction: false,
      },
      op
    );
    this.swiper.params.autoplay = this.options;
    this.swiper.autoplay.start();
  }
  stop() {
    this.autoplay.stop();
  }
}

export { MvSwiper, ArticleNavigationSwiper };
